import { z } from 'zod';

// チケット販売をご希望の方へのフォームのバリデーションスキーマ
export const ticketInquiryFormSchema = z.object({
  lastName: z.string().min(1, '姓は必須です').max(50, '姓は50文字以内で入力してください'),
  firstName: z.string().min(1, '名は必須です').max(50, '名は50文字以内で入力してください'),
  companyName: z
    .string()
    .min(1, '会社名は必須です')
    .max(100, '会社名は100文字以内で入力してください'),
  phone: z
    .string()
    .min(1, '電話番号は必須です')
    .regex(/^[\d\-()\s]+$/, { message: '正しい電話番号の形式で入力してください' })
    .refine(val => val.replace(/[\d]/g, '').length < val.length, {
      message: '正しい電話番号の形式で入力してください',
    }),
  email: z
    .string()
    .min(1, 'メールアドレスは必須です')
    .email({ message: '正しいメールアドレスの形式で入力してください' }),
  url: z
    .string()
    .trim()
    .max(100, '会社もしくはイベントのホームページは100文字以内で入力してください')
    .refine(
      val => {
        if (val === '') return true;
        try {
          const parsed = new URL(val);
          return parsed.protocol === 'http:' || parsed.protocol === 'https:';
        } catch {
          return false;
        }
      },
      { message: '正しいURLの形式で入力してください' }
    )
    .optional(),
  inquiryContent: z
    .string()
    .min(1, 'お問い合わせ内容は必須です')
    .max(1000, 'お問い合わせ内容は1000文字以内で入力してください'),
  privacyPolicy: z.boolean().refine(val => val === true, {
    message: '個人情報の取り扱いについて同意してください',
  }),
});

// バリデーション済みのフォームデータの型
export type TicketInquiryFormData = z.infer<typeof ticketInquiryFormSchema>;

// バリデーションエラーの型
export type TicketInquiryFormErrors = z.ZodError<TicketInquiryFormData>;
